const Ch02Page001 = () => {

    return(
        <div>
            <h1>Conclusion</h1>
            <p>It's time to experiment with being aware of personal quantum entanglements, which is another way of saying building healthy relationships, not just with people, but everything.  Avoid associations that cause harm.  So obvious but we forget.</p>            
        </div>
    )
};

export default Ch02Page001